import React from "react";
import BehaviourBarGraph from "../BehaviourBarGraph.jsx";
import { formatDuration } from "@signolteam/shared/units-of-measure";

let defaultMetadata = {
  me_1_running_hours: 3.083,
  me_1_shaft_generator_hours: 3.13,
  me_1_min_rpm: 139,
};

export const behaviourMetadataFields = Object.keys(defaultMetadata);
export default function graph({
  bvrColour,
  metadata = defaultMetadata,
  missingDataMsg,
  isExample,
}) {
  const engineRunningHours = Number(metadata["me_1_running_hours"]);
  const generatorRunningHours = Number(metadata["me_1_shaft_generator_hours"]);
  const shipSpecificMinRPM = Number(metadata["me_1_min_rpm"]);

  if (
    isNaN(engineRunningHours) ||
    isNaN(generatorRunningHours) ||
    isNaN(shipSpecificMinRPM)
  ) {
    return (
      <div className="relative text-center my-6 mx-auto text-2xl fill-current">
        {missingDataMsg}
      </div>
    );
  }

  const engineRunningSeconds = engineRunningHours * 60 * 60;
  const generatorRunningSeconds = generatorRunningHours * 60 * 60;

  const data = [
    {
      name: "Main Engine",
      mobileName: "Label 1",
      beforeThreshold: engineRunningSeconds,
      afterThreshold: 0,
      underThresholdColour:
        generatorRunningSeconds >= engineRunningSeconds
          ? bvrColour.codes["500"]
          : bvrColour.codes["200"],
      overThresholdColour: bvrColour.codes["500"],
    },
    {
      name: "Shaft Generator",
      mobileName: "Label 2",
      beforeThreshold:
        generatorRunningSeconds > engineRunningSeconds
          ? engineRunningSeconds
          : generatorRunningSeconds,
      afterThreshold:
        generatorRunningSeconds > engineRunningSeconds
          ? generatorRunningSeconds - engineRunningSeconds
          : 0,
      underThresholdColour:
        generatorRunningSeconds >= engineRunningSeconds
          ? bvrColour.codes["500"]
          : bvrColour.codes["200"],
      overThresholdColour: bvrColour.codes["500"],
    },
  ];

  const domainMin = 0;
  const margin = 0.2 * engineRunningSeconds;
  const domainMax =
    generatorRunningSeconds < engineRunningSeconds
      ? Math.ceil((engineRunningSeconds + margin) / 10) * 10
      : Math.ceil((generatorRunningSeconds + margin) / 10) * 10;
  const domain = [domainMin, domainMax];

  const mobileMargin =
    generatorRunningSeconds < engineRunningSeconds
      ? 0.1 * engineRunningSeconds
      : 0.1 * generatorRunningSeconds;
  const mobileDomainMax =
    generatorRunningSeconds < engineRunningSeconds
      ? Math.ceil(engineRunningSeconds + mobileMargin)
      : Math.ceil(generatorRunningSeconds + mobileMargin);
  const mobileDomain = [domainMin, mobileDomainMax];

  const thresholdLineColour = bvrColour.codes["900"];

  const numOfTicks =
    generatorRunningSeconds <= engineRunningSeconds
      ? Math.ceil(engineRunningHours)
      : Math.ceil(generatorRunningHours);

  const ticks = [];
  for (let i = 0; i < numOfTicks; i++) {
    ticks.push((i + 1) * 60 * 60);
  }

  return (
    <BehaviourBarGraph
      data={data}
      threshold={engineRunningSeconds}
      thresholdLabel={"Signol threshold"}
      mobileDomain={mobileDomain}
      domain={domain}
      refLineColour={thresholdLineColour}
      success={generatorRunningSeconds >= engineRunningSeconds}
      unitOfMeasure={"hrs"}
      axisLabel={
        isExample
          ? "Running hours above the vessel-specific ME RPM"
          : `Running hours above ${shipSpecificMinRPM} ME RPM`
      }
      hideYLine={true}
      hideNum={true}
      barLabelFormatter={(value) => `${formatDuration(value).formattedValue}`}
      ticks={ticks}
      isExample={isExample}
    />
  );
}
